import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import './Header.css'
import { Link,animateScroll as scroll } from "react-scroll";
import {FaBars,FaTimes} from 'react-icons/fa'
function Header() {

    const [click,setClick]=useState(false);

    const [show,handleShow]=useState(false);
    const transitionNavbar=(e)=>{
        // console.log(e);
        if(window.scrollY>730 && window.innerWidth>=768){
            // console.log(window.scrollY);
          handleShow(true);
          
    }
   else{
       handleShow(false);
   }
}

const scrollToTop=()=>{
    scroll.scrollToTop();
}

const handleClick=()=>{
    setClick(!click)
}
    

    useEffect(()=>{

        window.addEventListener('scroll',transitionNavbar);
        return ()=>window.removeEventListener('scroll',transitionNavbar);
    },[])
    
    return (
       <Navbar className={show ? "navbartransition" : "navbar"}>
           <NavbarContainer className={click ? "navcontainer" : null}>

           <NavbarLogo className={show ? "logotransition" : null} onClick={scrollToTop}>
               <div>S</div>

               
               </NavbarLogo>
               <div className="menu-icon" onClick={handleClick}>
                    
                {click ? <FaTimes/> : <FaBars/>}
                </div>

           
                   <Lists>
               <ul className={click ? "nav-menu active": 'nav-menu'}>
                      
                       <li className={show ? "navtransition" : null}><Link to="about" activeClass="active"  spy={true} smooth={true}>About</Link></li>
                       

                   <li className={show ? "navtransition" : null} ><Link to="works" activeClass="active"  spy={true} smooth={true}>Works</Link></li>
                   <li className={show ? "navtransition" : null} ><Link to="contact" activeClass="active"  spy={true} smooth={true}>Contact</Link></li>
               </ul>
                       </Lists>
           </NavbarContainer>

           
           
           </Navbar>

    )
}


export default Header
//URGENT!!//
//navbar position and padding and animation
const Navbar=styled.div`
// position:absolute;
padding-top:15px;

color:whitesmoke;
max-height:15vh;
width:100%;
z-index:1;
`;
const NavbarContainer=styled.div`
display:flex;
justify-content:space-between;
align-items:center;
`;

const NavbarLogo=styled.div`
margin-left:5vw;
div{
    font-size:3em;
    
    width:50px;
    text-align:center;
    border:2px solid white;
:hover{
    cursor:pointer;
}
 }`;


const Lists=styled.div`
ul{
    display:flex;
    list-style-type:none;
    margin-right:5em;
   
}
li{
    text-transform:uppercase;
    letter-spacing:2px;
    font-weight:500;
    padding-left:10px;
    padding-right:10px;
    transition:all 0.3s ease-in-out;
}
li:hover{
     color:grey;
    text-decoration:underline;
    cursor:pointer;
}
`;

